import { Image, Descriptions, Button } from 'antd';
import { ArrowLeftOutlined } from "@ant-design/icons"
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom"
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const DetailMovies = () => {
    let {id} = useParams()
    const [ movies, setMovies ] = useState({}) 
    let history = useHistory()

    useEffect(()=>{
        const fetchData = async ()=>{
            let result = await axios.get(`https://super-bootcamp-backend.sanbersy.com/api/movies/${id}`)
            let dataMovies = result.data
            setMovies(dataMovies) 
        }
        fetchData()
    },[])

    const HandleBack = ()=>{
        history.push("/movies")
    }
    
    
    return(
        <>
        <Button type="danger" icon={<ArrowLeftOutlined />} size="large" style={{marginBottom: "20px"}} onClick={HandleBack}>
            Kembali
        </Button>
        <Descriptions title="Movie Info" bordered>
        <Descriptions.Item label="Image" span={23}>
        <Image src={movies.image_url} width={200}></Image></Descriptions.Item>
        <Descriptions.Item label="Title" span={3}>{movies.title}</Descriptions.Item> 
        <Descriptions.Item label="Year">{movies.year}</Descriptions.Item>
        <Descriptions.Item label="Duration">{movies.duration} minutes</Descriptions.Item>
        <Descriptions.Item label="Rating">{movies.rating}/10</Descriptions.Item>
        <Descriptions.Item label="Genre">{movies.genre}</Descriptions.Item>
        <Descriptions.Item label="Review" span={2}>{movies.review}</Descriptions.Item>
        <Descriptions.Item label="Description" span={3}>{movies.description}</Descriptions.Item>
        </Descriptions>
        </>
    )
}

export default DetailMovies